// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__FbQdD","text":"FAQ_text__3ti1o"};